export default __webpack_public_path__ + "scripts/resource/2846f4640d476860e88f7aaa47d2b880.svg";